import config from '@/config';
import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export const useCreateTaskEmail = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading, error } = useMutation(values => api.base
        .post(`${config.appUrls.documents}/api/emails/TaskEmail/${values.taskId}/${values.relationId}`)
        .then(res => res.data), {
        onError: e => {
            handleHttpError(intl)(e);
        },
    });
    return {
        createTaskEmail: mutateAsync,
        isLoading,
        error,
    };
};
